import { loadEntityCategories, showEntityCategories } from "#/admin/legacy/page-builder/list-editor-categories.js";
import "#legacy/admin/page_builder/modals/base.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Modal ??= {};

Sparkle.PageBuilder.Modal.ListEditor = class ListEditor extends Sparkle.PageBuilder.Modal.Base {
  constructor(options) {
    super(
      jQuery.extend(true, options, {
        body: Sparkle.HandlebarsTemplates["list-editor-modal"]({
          entityItems: options.entityItems,
          entityType: options.entityType,
        }),
      }),
    );
    this.handleEntityTypeChange = this.handleEntityTypeChange.bind(this);
    this.resetCategorySelectOptions = this.resetCategorySelectOptions.bind(this);
    this.getOutput = this.getOutput.bind(this);
    if (options == null) {
      options = {};
    }
    this.entitySelect = this.page.element.querySelector("[data-behaviour~=entity-type-select]");
    this.categorySelect = this.page.element.querySelector("[data-behaviour~=category-id-select]");

    this.categories = [];
    this.savedCategoryId = options.categoryId;
    this.choicesReady = this.waitForChoices(this.initializeCategories(options));

    // BEHAVIOUR

    this.entitySelect.addEventListener("change", this.handleEntityTypeChange);
  }

  // EVENT HANDLERS

  handleEntityTypeChange(event) {
    this.savedCategoryId = "";
    this.categorySelect.value = "";
    this.categorySelect.dispatchEvent(new Event("change", { bubbles: true }));

    return this.resetCategorySelectOptions(event.target.value);
  }

  // HELPER FUNCTIONS

  async initializeCategories(options) {
    const payload = await loadEntityCategories(this.entitySelect, this.categorySelect, options.categoryId);

    this.categoriesLoaded = Boolean(payload);

    if (payload) {
      this.categories = payload.items;
    }

    return payload;
  }

  resetCategorySelectOptions(entityType) {
    showEntityCategories(this.entitySelect, this.categorySelect, this.categories, entityType);
  }

  // Without its categories the picker is empty, so the saved category stays until the entity type changes.
  getOutput() {
    return {
      entity_type: this.entitySelect.value,
      category_id: this.categoriesLoaded ? this.categorySelect.value : this.savedCategoryId,
    };
  }
};
Sparkle.PageBuilder.Modal.ListEditor.prototype.template = "list-editor-modal";
Sparkle.PageBuilder.Modal.ListEditor.prototype.title = "List Component";
